import type { AnonymizationResult } from "../domain/engine";
import { exportCoverageReport, exportDataset } from "../domain/export";
import { downloadFile } from "../lib/download";

interface ExportPanelProps {
  result: AnonymizationResult;
}

export function ExportPanel({ result }: ExportPanelProps) {
  const runId = result.output.runId;

  function handleExportDataset(format: "json" | "csv") {
    const exported = exportDataset(runId, result.maskedRecords, result.fieldOrder, format);
    downloadFile(exported.filename, exported.content, exported.mimeType);
  }

  function handleExportReport(format: "markdown" | "json") {
    const exported = exportCoverageReport(
      runId,
      result.output.evidence.scenarioId,
      result.fieldProfiles,
      result.coverage,
      result.output.findings,
      format,
    );
    downloadFile(exported.filename, exported.content, exported.mimeType);
  }

  return (
    <div>
      <h3>Exportar</h3>
      <p className="field-hint">
        Las exportaciones solo incluyen el dataset ya enmascarado según las reglas activas — nunca los valores
        originales de un campo cubierto.
      </p>
      <div className="action-row">
        <button type="button" className="button button-secondary" onClick={() => handleExportDataset("json")}>
          Dataset enmascarado (JSON)
        </button>
        <button type="button" className="button button-secondary" onClick={() => handleExportDataset("csv")}>
          Dataset enmascarado (CSV)
        </button>
        <button type="button" className="button button-secondary" onClick={() => handleExportReport("markdown")}>
          Informe de cobertura (Markdown)
        </button>
        <button type="button" className="button button-secondary" onClick={() => handleExportReport("json")}>
          Informe de cobertura (JSON)
        </button>
      </div>
    </div>
  );
}
